import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CustomerTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'

const Customer: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const userId = /^\/customer\/.+$/.test(pathname) ? pathname.split('/customer/')[1] : null

  return (
    <Layout headline={'お客さまリスト'} iconPath={'/icon/white/face.svg'} title={'お客さまリスト'}>
      {userId !== null && <CustomerTemplate userId={userId} />}
    </Layout>
  )
}

export default Customer
